var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pt-transport"},[_c('r-table-list',{attrs:{"data":_vm.data,"fields-names":_vm.fieldsExplanation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }